import React from "react";
import Container from "reactstrap/lib/Container";
import { SortPanel } from "ComponentsUI/Sort";
import withStyles from "react-jss";
import OrientationChanger from "ComponentsUI/OrientationChanger";
import { TagButton } from "ComponentsUI/Buttons";
import { StubItem } from "ComponentsUI/Stub";

const styles = (theme) => ({
	search: {
		display: "flex",
		flexDirection: "row",
		marginBottom: "50px",
	},
	tag: {
		marginBottom: "50px",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		search: {
			flexDirection: "column",
		},
	},
});

class TagsStub extends React.Component {
	generateSearch() {
		let array = [];
		for (let i = 0; i < 3; i++) {
			array.push(<StubItem key={`Search${i}`} search={true} />);
		}
		return array;
	}

	generateTagsStub() {
		let array = [];
		for (let i = 0; i < this.props.amount; i++) {
			array.push(<TagButton stub={true} key={`tags${i}`} />);
		}
		return array;
	}

	generateSort() {
		let sortItems = [
			{
				key: "date",
				name: null,
			},
		];
		let selectedSort = { item: { key: "date" } };

		let orientationChanger = !this.props.withoutSwitchers ? (
			<OrientationChanger onChange={() => {}} stub={true} flat={false} />
		) : null;

		return <SortPanel stub={true} orientationChanger={orientationChanger} />;
	}

	render() {
		let classes = this.props.classes;
		return (
			<React.Fragment>
				<Container>
					{this.props.search && <div className={classes.search}>{this.generateSearch()}</div>}
					{this.props.tagsList && <div className={classes.tag}>{this.generateTagsStub()}</div>}
					{this.props.sort && this.generateSort()}
				</Container>
			</React.Fragment>
		);
	}
}

export default withStyles(styles)(TagsStub);
